import React, { useEffect, useState } from "react";
import LoanSummary from "./components/LoanSummary/LoanSummary";
import Tabs from "./components/Tabs/Tabs";
import EMICalendar from "./components/EMICalendar/EMICalendar";
import Transactions from "./components/Transactions/Transactions";
import Documents from "./components/Documents/Documents";
import EMIsAPI from "../../services/emi-api";
import PayNow from "./components/PayNow/PayNow";
import { useNavigate } from "react-router-dom";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function LoanDetails() {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("EMI Calendar");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchAPI = async () => {
      const { repaymentDataAPI } = new EMIsAPI();
      const res = await repaymentDataAPI();
      if (res?.success) {
        setData(res.data);
        if (res.data.loanSummary.status === "Closed" || res.data.loanSummary.status === "Settlement") {
          navigate("/home");
        }
      }
    };

    fetchAPI();
  }, []);

  // console.log(data);

  useEffect(() => {
    !data ? handleShowContextualLoader("Please wait...") : handlehideContextualLoader();
  }, [data]);

  if (!data) {
    return null;
  }
  return (
    <div className="wrapper bg-white" style={{ height: "auto" }}>
      <LoanSummary loanSummary={data?.loanSummary} />

      <Tabs tab={tab} setTab={setTab} />

      {tab === "EMI Calendar" && <EMICalendar getEmis={data?.getEmis} loanSummary={data?.loanSummary} />}
      {tab === "Transactions" && <Transactions getTransections={data?.getTransections} />}
      {tab === "Documents" && <Documents emiDocs={data?.emiDocs} />}

      {data?.loanSummary?.amountToBeRepayed > 0 && <PayNow loanSummary={data?.loanSummary} />}
    </div>
  );
}
